import { IMember } from '../group/groupState';

export interface IPersonState {
    currentUser?: IMember;
}

export const initialPersonState: IPersonState = {
    currentUser: undefined
}